import {ChatEngine} from 'react-chat-engine' ;
import "./App.css";
import ChatFeed from './components/ChatFeed'
import Login from './components/Login';


const App = () =>{

    if(!localStorage.getItem('username'))return <Login/>

return(
    <ChatEngine
    
     height = "100vh"
     projectID = "2f40a4f7-1e90-4360-a521-59374e20545c"
     userName = {localStorage.getItem('username')}
     userSecret = {localStorage.getItem('password')}
     renderChatFeed = { (chatAppProps) => <ChatFeed {... chatAppProps}></ChatFeed>  }
    
    />
    
) ;
}

export default App ; 